<template>
    <div class="sine-wave about__video-mute" @click="toggleMute" role="button">
    </div>
</template>

<script>
import gsap from 'gsap';

let dpi= window.devicePixelRatio || 1;

export default {
    data() {
        return {
            muted: true,
            canvas: null,
            ctx: null,
            width: null,
            height: null,
            amp: {
                value: 3
            },
            wL: null,
            speed: null
        }
    },

    mounted() {
        this.initSine();

        EventBus.$on('set-mute', this.setMute);
    },

    methods: {
        toggleMute() {
            this.muted = !this.muted;
            EventBus.$emit('toggleMute', this.muted);
            gsap.to(this.amp,{ value: this.muted ? 3 : 10 , duration: 0.5 });
        },

        setMute(muted) {
            this.muted = muted;
            EventBus.$emit('toggleMute', muted);
            gsap.to(this.amp,{ value: this.muted ? 3 : 10 , duration: 0.5 });
        },

        initSine() {
            this.container = document.querySelector('.sine-wave');
            this.canvas = document.createElement('canvas');
            this.container.appendChild(this.canvas);
            this.ctx = this.canvas.getContext('2d');
            this.width = this.ctx.canvas.width = this.container.offsetWidth * dpi;
            this.height = this.ctx.canvas.height = this.container.offsetHeight * dpi;

            this.ctx.strokeStyle = '#fff';
            this.ctx.lineWidth = window.dpi;

            this.amp = {
                value: 3
            };
            this.wL = 0.1;
            this.speed = 0.003;

            window.requestAnimationFrame(this.updateSine);
        },

        updateSine() {
            this.ctx.clearRect(0, 0, this.width, this.height);
            this.ctx.beginPath();

            let inc = 0

            while (inc < this.width) {
                if (inc == 0) {
                    this.ctx.moveTo(inc, this.height / 2 + this.amp.value * dpi * Math.sin(inc * (1 / (this
                        .container.offsetWidth * 0.01)) * this.wL / dpi + Date.now() * this.speed));
                } else {
                    this.ctx.lineTo(inc, this.height / 2 + this.amp.value * dpi * Math.sin(inc * (1 / (this
                        .container.offsetWidth * 0.01)) * this.wL / dpi + Date.now() * this.speed));
                }
                inc += 2;
            }

            this.ctx.stroke();
            this.ctx.closePath();

            window.requestAnimationFrame(this.updateSine);
        }
    },
}
</script>

<style scoped lang="scss">
.sine-wave {
    width: 2vw;
    height: 2vw;
    position: absolute;
    bottom: 10px;
    right: 10px;
    opacity: 1;
    cursor: pointer;
    background-color: black;
    mix-blend-mode: difference;
    pointer-events: initial;

    canvas {
        position: absolute;
        bottom: 0px;
        right: 0px;
    }
}
</style>